import { AxiosInstance } from 'axios'
import axiosInstance from '@/api/index'
import { GenderType } from '@/utils/genders'

export interface HorseRequest {
  id?: number
  name: string
  motherId?: number
  fatherId?: number
  birthday: string
  deathday?: string
  twins: boolean
  embryo: boolean
  gender: '' | GenderType
  robe: string
  birthCountry: string
  breed: string
  blackType?: string
  sireId?: string
  microchipId?: string
  oldMicrochipId?: string
  assimile: boolean
  assimilable: boolean
  criteriumArqana: boolean
  breedersCup: boolean
  breedersChallenge: boolean
  sectionEndurance: boolean
  feeQualified: boolean
  strangerRegim: boolean
  blacktypeMother: boolean
  pedigree?: string
}

export interface Horse extends HorseRequest {
  mother?: Horse
  father?: Horse
}

export const defaultHorse: HorseRequest = {
  name: '',
  motherId: undefined,
  fatherId: undefined,
  birthday: '',
  deathday: undefined,
  twins: false,
  embryo: false,
  gender: '',
  robe: '',
  birthCountry: 'FR',
  breed: 'PS',
  blackType: undefined,
  sireId: undefined,
  microchipId: undefined,
  assimile: false,
  assimilable: false,
  criteriumArqana: false,
  breedersCup: false,
  breedersChallenge: false,
  sectionEndurance: false,
  feeQualified: true,
  strangerRegim: false,
  blacktypeMother: false,
  pedigree: '',
}

class IfceApi {
    private axios: AxiosInstance

    public constructor(axios: AxiosInstance) {
      this.axios = axios
    }

    public async findBySireOnApi(sireId: string): Promise<Horse> {
      return (await this.axios.get('/ifce/horse/', {
        params: { sireId },
      })).data
    }

    public async findByMicrochipOnApi(microchipId: string): Promise<Horse> {
      return (await this.axios.get('/ifce/horse/', {
        params: { microchipId },
      })).data
    }
}

export const ifceApi = new IfceApi(axiosInstance)
